import { type InjectionKey, reactive, ref } from "vue";

export type Logger = ReturnType<typeof useLogger>;
export const LOGGER: InjectionKey<Logger> = Symbol("LOGGER");

export const useLogger = () => {
  // Each app instance will have a pseudo random logId to easily separate the logs
  const logId = ref(crypto.randomUUID().slice(0, 4));
  const logPrefix = ref(`[AVP 3DWS Deck](${logId.value}):`);

  function debug(...data: any[]): void {
    // eslint-disable-next-line no-console
    console.debug(logPrefix.value, ...data);
  }

  function info(...data: any[]): void {
    // eslint-disable-next-line no-console
    console.info(logPrefix.value, ...data);
  }

  function warn(...data: any[]): void {
    // eslint-disable-next-line no-console
    console.warn(logPrefix.value, ...data);
  }

  function error(...data: any[]): void {
    // eslint-disable-next-line no-console
    console.error(logPrefix.value, ...data);
  }

  return reactive({
    debug: debug,
    info: info,
    warn: warn,
    error: error,
    logId: logId
  });
};
